import React from 'react';
import { bool, string, number, oneOfType } from 'prop-types';
import numeral from 'numeral';

const Number = ({ value, format, isPrice, negative, ...props }) => {
    const number = String(Math.ceil(parseInt(value)));
    return (
        <span {...props}>
            { negative && '-' }
            {
                numeral(number)
                    .format(isPrice ? '$0,0[.]00' : '0,0[.]00')
                    .replace(/,/g, '.')
                    .replace(/-/g, '')
            }
        </span>
    );
};

Number.propTypes = {
    value: oneOfType([number, string]),
    format: string,
    isPrice: bool,
    negative: bool
};

Number.defaultProps = {
    format: '0,0[.]00 $',
    isPrice: true,
    negative: false
};

export default Number;
